import http from '../utils/http';
import i18n from '@/main';

const baseRoute = '/certidao-ibama';

export default {

    buscarCertidao(cpfCnpj) {
        return http.get({
            url: baseRoute + `/${cpfCnpj}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.exportandoCertidaoIbama')
        });
    }
};
